import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDiagramTree32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconDiagramTree32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M26 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m2 0a3 3 0 0 1-5.83 1H21a2 2 0 0 0-2 2v4h3.17a3.001 3.001 0 1 1 0 2H19v4a2 2 0 0 0 2 2h1.17a3.001 3.001 0 1 1 0 2H21a4 4 0 0 1-4-4v-4h-3v4a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V11a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v4h3v-4a4 4 0 0 1 4-4h1.17A3.001 3.001 0 0 1 28 8m-4 16a1 1 0 1 0 2 0 1 1 0 0 0-2 0M7 10h4a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1m18 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDiagramTree32);
